import { useState } from "react";
import { Lock } from "lucide-react";
import { api, errorText } from "@/lib/api";

export default function AdminLogin({ onSuccess }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/login", { password });
      onSuccess();
    } catch (err) {
      setError(errorText(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#05060f] flex items-center justify-center relative overflow-hidden">
      <img src="/assets/koselig-hero.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#05060f] via-[#05060f]/70 to-[#05060f]/40" />
      <form onSubmit={submit} className="relative w-full max-w-sm p-8 rounded-xl border border-amber-500/25 bg-[#0d0f16]/90 backdrop-blur-md launcher-rise" data-testid="admin-login-form">
        <Lock className="text-amber-400 mb-6" size={26} />
        <h1 className="font-display text-xl tracking-[0.15em] text-amber-200 ">Panel administracyjny</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">Podaj hasło, aby kontynuować.</p>
        <input type="password" autoFocus value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Hasło" data-testid="admin-password-input"
          className="w-full bg-black/40 border border-white/10 rounded px-3 py-2.5 text-sm focus:border-amber-500/60 outline-none transition-colors" />
        {error && <p className="text-xs text-red-300 mt-2" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy || !password} className="mt-5 w-full py-2.5 bg-amber-500 text-white font-bold rounded hover:bg-amber-400 disabled:opacity-50 transition-colors text-sm" data-testid="admin-login-submit">
          {busy ? "Logowanie..." : "Zaloguj"}
        </button>
      </form>
    </div>
  );
}
